import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from "react";
import { useSelector } from "react-redux";
import { ViewCardSizePreference } from "~/components/ViewControls/ViewVisiblityToggleMenu/ViewCardSizePreference";
import { usePublicCustomFieldsContext } from "~/providers/PublicCustomFieldsProvider";
import { configViewVisiblityOptionsSelector, currentViewTypeNameSelector, customFieldVisibilityOptionsSelector } from "~/store/configViews/selectors";
import { ConfigViewVisbilityOptions } from "./ConfigViewVisbilityOptions";
import { CustomFieldsVisbilityOptions } from "./CustomFieldsVisbilityOptions";
import { ViewVisibilityToggleMenu } from "./ViewVisibilityToggleMenu";
export const PublicViewVisibilityToggleMenu = /*#__PURE__*/ memo(()=>{
    const customFieldOptions = useSelector(customFieldVisibilityOptionsSelector);
    const configViewOptions = useSelector(configViewVisiblityOptionsSelector);
    const showCustomFieldsOptions = customFieldOptions.length > 0;
    const showConfigViewOptions = configViewOptions.length > 0;
    const { customFields } = usePublicCustomFieldsContext();
    const currentViewTypeName = useSelector(currentViewTypeNameSelector);
    return /*#__PURE__*/ _jsx(ViewVisibilityToggleMenu, {
        children: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                currentViewTypeName === "gallery" && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(ViewCardSizePreference, {}),
                        /*#__PURE__*/ _jsx("div", {
                            className: "-mx-1.5 my-2 h-px shrink-0 bg-grey-4"
                        })
                    ]
                }),
                showConfigViewOptions && /*#__PURE__*/ _jsx(ConfigViewVisbilityOptions, {
                    options: configViewOptions
                }),
                showConfigViewOptions && showCustomFieldsOptions && /*#__PURE__*/ _jsx("div", {
                    className: "-mx-1.5 my-2 h-px bg-grey-4"
                }),
                showCustomFieldsOptions && customFields && /*#__PURE__*/ _jsx(CustomFieldsVisbilityOptions, {
                    customFields: customFields,
                    options: customFieldOptions
                })
            ]
        })
    });
});
PublicViewVisibilityToggleMenu.displayName = "PublicViewVisibilityToggleMenu";
